export default __webpack_public_path__ + "static/trackthebat4-6ff60a258381d73ecf097b9024ae886a.png";